<template>
	<div class="grid">
		<div class="col-12">
			<div class="card">
				<Toast/>
				<DataTable ref="dt" :value="proformas" v-model:selection="selectedProforma" selectionMode="single" @rowSelect="onProformaSelected" dataKey="id" :paginator="true" :rows="20" :filters="filters"
							paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[20,35,50]"
							currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} proformas" responsiveLayout="scroll">
					<template #header>
						<div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
							<h5 class="m-0">Proformas</h5>
							<div id="table-header-inputs-container">
								<span id="table-search-input" class="block mt-2 md:mt-0 p-input-icon-left">
									<i class="pi pi-search" />
									<AutoComplete placeholder="Buscar por cliente..." ref="autocomplete" :dropdown="false" :multiple="false" v-model="filters['global'].value" @complete="onSearchProformas($event)"></AutoComplete>
								</span>
								<span id="table-buttons-container" class="block mt-2 md:mt-0">
									<Button icon="pi pi-plus" class="p-button-rounded p-button-success mr-2" @click="openNew" />
								</span>
							</div>
							
						</div>
					</template>

                    <Column field="serialNumber" header="Serial" :sortable="true" headerStyle="width:10%; min-width:8rem;">
						<template #body="slotProps">
							<span class="p-column-title">Serie</span>
							{{slotProps.data.serial !== null && slotProps.data.serial !== undefined ? slotProps.data.serial.toString().padStart(9, "0") : slotProps.data.id.toString().padStart(9, "0") }}
						</template>
					</Column>
					<Column field="customer.name" header="Cliente" :sortable="true" headerStyle="width:30%; min-width:10rem;">
						<template #body="slotProps">
							<span class="p-column-title">Cliente</span>
							{{slotProps.data.customer.name}}
						</template>
					</Column>
					<Column field="total" header="Total" :sortable="true" headerStyle="width:20%; min-width:10rem;">
						<template #body="slotProps">
							<span class="p-column-title">Total</span>
							{{"$"+slotProps.data.total.toFixed(2)}}
						</template>
					</Column>
                    <Column field="createdAtFormatted" header="Fecha" :sortable="true" headerStyle="width:25%; min-width:10rem;">
						<template #body="slotProps">
							<span class="p-column-title">Fecha</span>
							{{slotProps.data.createdAtFormatted}}
						</template>
					</Column>
					<Column field="state" header="Estado" :sortable="true" headerStyle="width:25%; min-width:10rem;">
						<template #body="slotProps">
							<span :class="'status-badge status-' + slotProps.data.stateBadgeColor">{{slotProps.data.state}}</span>
						</template>
					</Column>
				</DataTable>
			</div>
		</div>
	</div>

</template>

<script>
// import download from 'downloadjs';
import {FilterMatchMode} from 'primevue/api';
import httpRequest from '../../service/httpRequest';
import Proforma from '../../models/proforma';

export default {
	data() {
		return {
			proformas: [],
            proforma: new Proforma(),
            selectedProforma: null,
			filters: {},
		}
	},
	created() {
        this.initFilters();
        this.getProformas();
	},
	mounted() {
    },
	methods: {
		openNew() {
			this.$router.push('form');
		},
        async getProformas(client=null) {
            let response = await httpRequest.getProformas(client);

            if (response.status == 200) {
                let proformas = response.data;
                this.proformas = proformas.map(function(data) { return new Proforma(data)});
            } else { console.log("Error: ", response.status); }
        },

		async onSearchProformas(event) {
			let response = await httpRequest.getProformas(event.query);
            if (response.status == 200) {
                let proformas_ = response.data;
				for (var index in proformas_) {
					if (!this.proformas.some(proforma => (proforma.id == proformas_[index].id))) {
						this.proformas.push(new Proforma(proformas_[index]));
					}
				}
            } else { console.log("Error: ", response.status); }
		},

		initFilters() {
            this.filters = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            }
        },

		onProformaSelected(event) {
			let proforma = event.data;
			this.$router.push('form?id=' + proforma.id);
		},
	}
}
</script>

<style scoped lang="scss">
@import '../../assets/demo/badges.scss';

@media screen and (max-width: 769px) {
	#table-header-inputs-container {
		display: block;
	}
	#table-search-input {
		margin: 15px 0px !important;
	}
}
@media screen and (min-width: 769px) {
	#table-header-inputs-container {
		display: flex;
	}
	#table-search-input {
		margin: 0px 15px;
	}
}

.status-badge {
    border-radius: var(--border-radius);
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.status-badge {
    &.status-green {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-red {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-yellow {
        background: #FEEDAF;
        color: #8A5340;
    }

    &.status-orange {
        background: #ffa177;
        color: #da2727;
    }

	&.status-blue {
        background: #B3E5FC;
        color: #23677B;
    }

	&.status-gray {
        background: #d6d8d9;
        color: #464747;
    }
}
</style>
